import React from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";

import Dashboard from "@/pages/Dashboard";
import GlobalEvents from "@/pages/GlobalEvents";
import EventDetails from "@/pages/EventDetails";
import MorningBrief from "@/pages/MorningBrief";
import StockAnalysis from "@/pages/StockAnalysis";
import Settings from "@/pages/Settings";
import { SignUpPage, SignInPage } from "@/pages/AuthPages";
import { PrivacyPage, TermsPage, ContactPage } from "@/pages/LegalPages";
import { AuthProvider, useAuth } from "@/auth/AuthContext";
import { Layout } from "@/components/Layout";
import { GAListener } from "@/analytics/GAListener";
import { Toaster } from "@/components/ui/sonner";

function AuthGate({ children }) {
  const { user } = useAuth();
  if (user === undefined) {
    return <div className="min-h-screen bg-fij-bg" />;
  }
  if (!user) return <Navigate to="/login" replace />;
  return children;
}

function GuestGate({ children }) {
  const { user } = useAuth();
  if (user === undefined) return <div className="min-h-screen bg-fij-bg" />;
  if (user) return <Navigate to="/dashboard" replace />;
  return children;
}

function App() {
  return (
    <div className="App dark">
      <BrowserRouter>
        <AuthProvider>
          <GAListener />
          <Toaster theme="dark" position="top-right" richColors closeButton />
          <Routes>
              <Route element={<Layout />}>
                <Route path="/" element={<Dashboard seoPath="/" />} />
                <Route path="/dashboard" element={<Dashboard />} />
                {/* Financial Journal — SEO-friendly alias + legacy path. */}
                <Route path="/financial-journal" element={<GlobalEvents />} />
                <Route path="/events" element={<GlobalEvents />} />
                <Route path="/events/:id" element={<EventDetails />} />
                {/* Stock Analysis — SEO-friendly alias + legacy path. */}
                <Route path="/stock-analysis" element={<StockAnalysis />} />
                <Route path="/stocks" element={<StockAnalysis />} />
                <Route path="/morning-brief" element={<MorningBrief />} />
                <Route path="/settings" element={<AuthGate><Settings /></AuthGate>} />
              </Route>
              {/* Public legal pages — accessible without authentication. */}
              <Route path="/privacy" element={<PrivacyPage />} />
              <Route path="/terms"   element={<TermsPage />} />
              <Route path="/contact" element={<ContactPage />} />
              <Route path="/signup" element={<GuestGate><SignUpPage /></GuestGate>} />
              <Route path="/login"  element={<GuestGate><SignInPage /></GuestGate>} />
              <Route path="*" element={<Navigate to="/" replace />} />
            </Routes>
        </AuthProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;
